import React from 'react';
import { ConfirmationDialog } from '../../../../shared/ui/dialogs';

export interface QuickFillNavigationGuardDialogProps {
  open: boolean;
  isContinuing: boolean;
  onStay: () => void;
  onLeave: () => void;
}

export const QuickFillNavigationGuardDialog: React.FC<QuickFillNavigationGuardDialogProps> = ({
  open,
  isContinuing,
  onStay,
  onLeave,
}) => (
  <ConfirmationDialog
    open={open}
    title="Abort current operation?"
    message={
      isContinuing
        ? 'Data is being saved to Revit. Are you sure you want to leave?'
        : 'Data is still loading from Revit. Are you sure you want to leave?'
    }
    cancelLabel="Stay"
    confirmLabel="Leave"
    confirmColor="warning"
    aria-labelledby="quickfill-navigation-guard-title"
    onCancel={onStay}
    onConfirm={onLeave}
  />
);
